import * as Sentry from "@sentry/browser";
import '../framework/ts/env';
import {getCookie} from "typescript-cookie";

if (APP_ENV !== 'local') {
    Sentry.init({
        environment: APP_ENV,
        release: APP_RELEASE,
        integrations: [],
        tracesSampleRate: 1.0,
        tunnel: '/sentry-tunnel',
        transportOptions: {
            dsn: "https://fa2e0d5741494aaebcdf157f227e4c7e@o13351.ingest.sentry.io/6437428",
            headers: {
                'X-XSRF-TOKEN': getCookie('XSRF-TOKEN') || '',
            },
            tunnel: '/sentry-tunnel',
        }
    });
}
